


















import {
  Component,
  Vue,
  Prop,
  Watch,
} from 'vue-property-decorator';
import SearchBar from '@/components/SearchBar.vue';
import { Action, Getter, Mutation } from 'vuex-class';
import {Application, Organisation} from '../types';
import Table from '@/components/Table.vue';
import ApplicationService from '@/services/application.service';


@Component({
  components: {
    Table,
    SearchBar,
  },
})
export default class  ApplicationsList extends Vue {
  public selectedApplication: Application | null = null;
  private applications: Application[] = [];
  @Prop({default: false}) private saved!: boolean;
  @Prop() private editApplication: any;
  @Prop({default: null}) private searchNames!: string;
  @Action private addAdminApplicationsAsync: any;
  @Getter private adminApplications: any;
  @Getter private adminApplicationsTabular: any;
  @Getter private applicationById: any;
  private tableData: any = {
    headers: [
      {
        text: 'Application',
        value: 'name',
        querySortKey: 'name',
      },
      {
        text: 'Organisation',
        value: 'organisations',
        querySortKey: 'organisations',
      },
      {
        text: 'Type',
        value: 'type',
        querySortKey: 'type',
      },
    ],
    rows: [],
    total: 0,
    filters: {},
  };
  private loading: boolean = false;

  public async loadApplications() {
    if (this.loading) {
      return;
    }
    this.loading = true;

    try {
      const response = await ApplicationService.getAdminApplications();
      Vue.set(this, 'applications', response.applications);

      Vue.set(
        this.tableData,
        'rows',
        this.applications.map((application: any) => {
          return {
            id: application.id,
            name: application.name,
            organisation_ids: application.organisations.map((org: Organisation) => org.id),
            organisations: application.organisations,
            type: application.type,
            reference: application.reference,
          };
        }),
      );
    } finally {
      this.loading = false;
    }
  }

  @Watch('saved')
  private async onSave() {
    await this.loadApplications();
  }

  private async mounted() {
    await this.loadApplications();
  }
}
